import $ from "jquery";
import axios from "axios";
import moment from "moment";
import authHeader from "./auth-header";
import ErrorService from "./error.service";
import ClientService from "./client.service";
import AdminService from "./admin.service";
import UserService from "./user.service";
import SurveyService from "./survey.service";
import TableService from "./table.service";

const BASE_URL = AdminService.getBaseUrl();
const API_URL = BASE_URL + "/api/v1/dashboard";
const DEFAULT_FONT_SIZE = 10;

const response = {
  data: {
    statusCode: 200,
    message: "placeholder message"
  }
};
function wordBreakFormatter(name) {
  if (typeof name != "undefined") {
    return name.replace('-',' ').split(" ").join("\n")
  }
}
function timePeriodFormatter(name) {
  if (typeof name != "undefined" && name.includes("P")) {
    if (name.includes("P1")) {
      let index = name.indexOf("-");
      let year = name.substr(0, index - 1);
      let abbreviatedYear = name.substr(2, 3);
      abbreviatedYear = "'" + abbreviatedYear;
      return abbreviatedYear;
    } else {
      return "";
    }
  }
  return name;
}
function getCompetititveYAxis(max = 5) {
  return {
    type: "value",
    data: [],
    min: 0,
    max: max,
    minInterval: 1,
    boundaryGap: true,
    inverse: true,
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    axisLabel: {
      fontSize: DEFAULT_FONT_SIZE,
      showMinLabel: false,
      showMaxLabel: false,
      fontFamily: "Franklin Gothic Demi Cond"
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: "#fff"
      }
    }
  };
}
function getCompetitiveXAxis(categories) {
  let configuration = {
    type: "category",
    data: categories,
    boundaryGap: false,
    splitLine: {
      show: true,
      lineStyle: {
        color: "#DCDCDC"
      }
    },
    axisTick: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisLabel: {
      rotate: 25,
      fontFamily: "Franklin Gothic Demi Cond",
      fontSize: DEFAULT_FONT_SIZE
    }
  };

  if (typeof categories != "undefined") {
    $.extend(true, configuration, { data: categories });
  }
  return configuration;
}
class DashboardService {
	DASHBOARD_PERIOD_SETTING_TYPE= "dashboard-period";
	DASHBOARD_RESPONDENTS_MAP_VIEW_SETTING_TYPE= "dashboard-respondents-map-view-by";
	DASHBOARD_PERFORMANCE_TRENDS_PERFORMANCE_SETTING_TYPE= "dashboard-performance-trends-performance";
  DASHBOARD_METRIC_CONTRIBUTIONS_METRIC_SETTING_TYPE= "dashboard-metric-contributions-metric";
	DASHBOARD_PERFORMANCE_TRENDS_METRIC_SETTING_TYPE= "dashboard-performance-trends-metric";
	DASHBOARD_COMPETITIVE_TRENDS_COMPETITOR_SET_SETTING_TYPE= "dashboard-competitive-trends-competitor-set";
	DASHBOARD_COMPETITIVE_TRENDS_RANK_BY_SETTING_TYPE= "dashboard-competitive-trends-rank-by";
	DASHBOARD_EXPECTATIONS_MAP_BY_SETTING_TYPE= "dashboard-expectations-map-by";
	DASHBOARD_COMPETITIVE_RANK_COMPETITOR_SET_SETTING_TYPE= "dashboard-competitive-rank-competitor-set";

  DASHBOARD_NEEDS_PROFILE_COMPETITOR_SETTING_TYPE= "dashboard-needs-profile-competitor";
  DASHBOARD_GROWTH_SEQUENCE_VIEW_COMPETITOR_TYPE= "dashboard-growth-sequence-competitor";
  DASHBOARD_WINNERS_MAP_VIEW_COMPETITOR_TYPE= "dashboard-winners-map-competitor";

	DASHBOARD_NEEDS_PROFILE_VIEW_SETTING_TYPE= "dashboard-needs-profile-view";
  DASHBOARD_GROWTH_SEQUENCE_VIEW_SETTING_TYPE= "dashboard-growth-sequence-view";
  DASHBOARD_WINNERS_MAP_VIEW_SETTING_TYPE= "dashboard-winners-map-view";

  DASHBOARD_NEEDS_PROFILE_COMPETITOR_SETTING_TYPE= "dashboard-needs-profile-competitor";
  DASHBOARD_GROWTH_SEQUENCE_COMPETITOR_SETTING_TYPE= "dashboard-growth-sequence-competitor";
  DASHBOARD_WINNERS_MAP_COMPETITOR_SETTING_TYPE= "dashboard-winners-map-competitor";

  DASHBOARD_NPS_RANK_GROUP_SETTING_TYPE = "dashboard-nps-rank-group";
  DASHBOARD_NPS_RANK_NUMBER_OF_TIERS_SETTING_TYPE = "dashboard-nps-rank-number-of-tiers";
  DASHBOARD_MOAT_SCORE_RANK_GROUP_SETTING_TYPE = "dashboard-moat-score-rank-group";
  DASHBOARD_MOAT_SCORE_RANK_NUMBER_OF_TIERS_SETTING_TYPE = "dashboard-moat-score-rank-number-of-tiers";
  DASHBOARD_W_SCORE_RANK_GROUP_SETTING_TYPE = "dashboard-w-score-rank-group";
  DASHBOARD_W_SCORE_RANK_NUMBER_OF_TIERS_SETTING_TYPE = "dashboard-w-score-rank-number-of-tiers";  
  DASHBOARD_MOAT_COMPS_COMPANY_SETTING_TYPE = "dashboard-moat-comps-company";
  DASHBOARD_MOAT_COMPS_GROUP_SETTING_TYPE = "dashboard-moat-comps-group";

  setDashboardSetting(defaultDashboardValues, userSettingTypeName, value){
    if (typeof defaultDashboardValues != "undefined") {
      let defaultDashboardValue = defaultDashboardValues.find(x => x.userSettingTypeName == userSettingTypeName);
      if (typeof defaultDashboardValue != "undefined") {
        defaultDashboardValue.userSettingValue = value;
      }
    }
    return defaultDashboardValues;
  }
  getDashboardSetting(defaultDashboardValues, userSettingTypeName, defaultValue, options){
    if (Array.isArray(defaultDashboardValues)){
      let defaultDashboardValue = defaultDashboardValues.find(x => x.userSettingTypeName == userSettingTypeName);
      if (typeof defaultDashboardValue != "undefined") {
        let returnValue = defaultDashboardValue.userSettingValue;
        let optionValue = options.find(x => x.value == returnValue);
        if (typeof optionValue != "undefined") {
          return returnValue;
        }
      }
      return defaultValue;    
    }
  }
  setW30AsDefaultSurveyGroup(surveyGroupOptions, inputSurveyGroupId){
    let w30IndexSurveyGroup = surveyGroupOptions.find(x => x.name == "W-30 Index");
    if (typeof w30IndexSurveyGroup != "undefined") {
      return w30IndexSurveyGroup.value;
    }
    return inputSurveyGroupId
  }  
  displayDashboardCard(layoutCards, code){
    var match = layoutCards.find((x) => x.dashboardCardTypeCode == code);
    return typeof match != "undefined";
  }  
  getDashboardLayoutCard(layoutCards, code){
    var match = layoutCards.find((x) => x.dashboardCardTypeCode == code);
    if (typeof match != "undefined") {
      return match;
    } else {
      return {
        dashboardCardTypeCode: "",
        sequenceNumber: 100,
        dashboardCardId: 0,
        id: 0
      };
    }
  }
  getParameters(clientCode, clientTimePeriodId) {
    const params = new URLSearchParams();
    params.append("clientCode", clientCode);
    params.append("clientTimePeriodId", clientTimePeriodId);
    params.append("userId", UserService.getUserId());
    params.append("surveyId", SurveyService.getSurveyId());
    return params;
  }
  async getDashboardCardDataList(callback, chartApp) {
    await axios
    .get(API_URL + "/get-dashboard-card-data", { headers: await authHeader() })
    .then(response => callback(response))
    .catch(error => {
      error.message += ErrorService.mergeError(error.response);
      ErrorService.processError("DashboardService.getBenchmarkSummaryDataList", error, "admin", chartApp);
    });    
  }
  async importDashboardCardData(file, callback, chartApp) {
    let formData = new FormData();
    formData.append("file", file);
    formData.append("user_id", UserService.getUserId());

    let headers = { "Content-Type": "multipart/form-data" };
    $.extend(headers, await authHeader());

    await axios
    .post(API_URL + "/import-dashboard-card-data", formData, { headers: headers })
    .then(response => callback(response))
    .catch(error => {
      error.message += ErrorService.mergeError(error.response);
      ErrorService.processError("DashboardService.importDashboardCardData", error, "admin", chartApp);
    });  

  }
  getTableColumnData() {
    return [
      { title: "User Id", data: "userId", name: "userId", width: "2rem" },
      { title: "Username", data: "userName", name: "userName", width: "10rem" },
      {
        title: "Dashboard Card Id",
        data: "dashboardCardId",
        createdCell: function(td, cellData, rowData, row, col) {
          $(td).addClass("text-center");
        },
        className: "",
        name: "dashboardCardId",
        width: "5rem"
      },
      { title: "Dashboard Card Type Id", data: "dashboardCardTypeId", name: "dashboardCardTypeId", width: "10rem" },
      { title: "Dashboard Card Name", data: "dashboardCardTypeName", name: "dashboardCardTypeName", width: "10rem" },
      { title: "Dashboard Card Code", data: "dashboardCardTypeCode", name: "dashboardCardTypeCode", width: "7rem" },
      { title: "Sequence Number", data: "sequenceNumber", name: "sequenceNumber", width: "5rem" },
      {
        title: "Date Created",
        data: "createdDate",
        type: "date",
        name: "createdDate",
        width: "5rem",
        render: function(data, type, row) {
          return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY");
        }
      },
      {
        title: "Date Updated",
        data: "updatedDate",
        type: "date",
        name: "updatedDate",
        width: "5rem",
        render: function(data, type, row) {
          return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY");
        }
      } 
    ];
  }

  async getWinnersMap(value, clientCompetitorId, view, callback, chartApp) {
    let clientTimePeriodId = value;
    let clientId = ClientService.getClientId();
    let surveyId = SurveyService.getSurveyId();
    if (surveyId == 0){
      chartApp.displayDashboard = true;
    }    
    if (clientId != 0 && surveyId != 0) {
      const params = new URLSearchParams();
      params.append("clientCode", ClientService.getClientCode());
      params.append("clientTimePeriodId", clientTimePeriodId);
      params.append("userId", UserService.getUserId());
      params.append("view", view);
      params.append("clientCompetitorId", clientCompetitorId);
      params.append("surveyId", surveyId);
      await axios
        .post(API_URL + "/get-winners-map", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          if (!error.message.includes("getAttribute")) {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("DashboardService.getNeedsProfile", error, "dashboard", chartApp);
          }
        });
    }
  }
  async getGrowthSequence(value, clientCompetitorId, view, callback, chartApp) {
    let clientTimePeriodId = value;
    let clientId = ClientService.getClientId();
    let surveyId = SurveyService.getSurveyId();
    if (surveyId == 0){
      chartApp.displayDashboard = true;
    }    
    if (clientId != 0 && surveyId != 0) {
      const params = new URLSearchParams();
      params.append("clientCode", ClientService.getClientCode());
      params.append("clientTimePeriodId", clientTimePeriodId);
      params.append("view", view);
      params.append("userId", UserService.getUserId());
      params.append("clientCompetitorId", clientCompetitorId);
      params.append("surveyId", surveyId);
      await axios
        .post(API_URL + "/get-growth-sequence", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          if (!error.message.includes("getAttribute")) {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("DashboardService.getGrowthSequence", error, "dashboard", chartApp);
          }
        });
    }
  }
  async getNeedsProfile(value, clientCompetitorId, view, callback, chartApp) {
    let clientTimePeriodId = value;
    let clientId = ClientService.getClientId();
    let surveyId = SurveyService.getSurveyId();
    if (surveyId == 0){
      chartApp.displayDashboard = true;
    }    
    if (clientId != 0 && surveyId != 0) {
      const params = new URLSearchParams();
      params.append("clientCode", ClientService.getClientCode());
      params.append("clientTimePeriodId", clientTimePeriodId);
      params.append("view", view);
      params.append("userId", UserService.getUserId());
      params.append("clientCompetitorId", clientCompetitorId);
      params.append("surveyId", surveyId);
      await axios
        .post(API_URL + "/get-needs-profile", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          if (!error.message.includes("getAttribute")) {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("DashboardService.getNeedsProfile", error, "dashboard", chartApp);
          }
        });
    }
  }
  async getCompetitiveRank(value, competitorSet, callback, chartApp) {
    let clientTimePeriodId = value;
    let clientId = ClientService.getClientId();
    let surveyId = SurveyService.getSurveyId();
    if (surveyId == 0){
      chartApp.displayDashboard = true;
    }    
    if (clientId != 0 && surveyId != 0) {
      const params = new URLSearchParams();
      params.append("clientCode", ClientService.getClientCode());
      params.append("clientTimePeriodId", clientTimePeriodId);
      params.append("userId", UserService.getUserId());
      params.append("competitorSet", competitorSet);
      params.append("surveyId", surveyId);
      await axios
        .post(API_URL + "/get-competitive-rank", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          if (!error.message.includes("getAttribute")) {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("DashboardService.getCompetitiveRank", error, "dashboard", chartApp);
          }
        });
    }
  }
  async getMoatComps(period, surveyGroupId, competitor,callback, chartApp) {
    let clientId = ClientService.getClientId();
    let surveyId = SurveyService.getSurveyId();
    if (surveyId == 0){
      chartApp.displayDashboard = true;
    }
    if (clientId != 0 && surveyId != 0) {
      const params = new URLSearchParams();
      params.append("clientCode", ClientService.getClientCode());
      params.append("surveyId", surveyId);
      params.append("surveyGroupId", surveyGroupId);
      params.append("competitorId", competitor);
      params.append("userId", UserService.getUserId());
      params.append("period", period);
      await axios
        .post(API_URL + "/get-moat-comps", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          if (!error.message.includes("getAttribute")) {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("DashboardService.clientId", error, "survey-designer", chartApp);
          }
        });
    }
  }
  async getPredictiveAnalytics(metricGroupId, period, useMetricGrowth, saveMetric, callback, chartApp) {
    let clientId = ClientService.getClientId();
    let surveyId = SurveyService.getSurveyId();
    if (surveyId == 0){
      chartApp.displayDashboard = true;
    }
    if (clientId != 0 && surveyId != 0) {
      const params = new URLSearchParams();
      params.append("clientCode", ClientService.getClientCode());
      params.append("surveyId", surveyId);
      params.append("userId", UserService.getUserId());
      params.append("period", period);
      params.append("saveMetric", saveMetric);
      params.append("metricGroupId", metricGroupId);
      params.append("useMetricGrowth", useMetricGrowth);
      await axios
        .post(API_URL + "/get-predictive-analytics", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          if (!error.message.includes("getAttribute")) {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("DashboardService.getPredictiveAnalytics", error, "survey-designer", chartApp);
          }
        });
    }
  }
  async getExpectationsMap(value, expectationsBy, callback, chartApp) {
    let clientTimePeriodId = value;
    let clientId = ClientService.getClientId();
    let surveyId = SurveyService.getSurveyId();
    if (surveyId == 0){
      chartApp.displayDashboard = true;
    }    
    if (clientId != 0 && surveyId != 0) {
      const params = new URLSearchParams();
      params.append("clientCode", ClientService.getClientCode());
      params.append("expectationsBy", expectationsBy);
      params.append("clientTimePeriodId", clientTimePeriodId);
      params.append("userId", UserService.getUserId());
      params.append("surveyId", surveyId);
      await axios
        .post(API_URL + "/get-expectations-map", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          if (!error.message.includes("getAttribute")) {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("DashboardService.getExpectationsMap", error, "dashboard", chartApp);
          }
        });
    }
  }
  async getCompetitiveTrends(rankBy, competitorSet, callback, chartApp) {
    if (!UserService.isLoggedIn()) {
      return;
    }
    let clientId = ClientService.getClientId();
    let surveyId = SurveyService.getSurveyId();
    if (surveyId == 0){
      chartApp.displayDashboard = true;
    }
    if (clientId != 0 && surveyId != 0) {
      const params = new URLSearchParams();
      params.append("clientCode", ClientService.getClientCode());
      params.append("rankBy", rankBy);
      params.append("competitorSet", competitorSet);
      params.append("userId", UserService.getUserId());
      params.append("surveyId", surveyId);
      await axios
        .post(API_URL + "/get-competitive-trends", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          if (!error.message.includes("getAttribute")) {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("DashboardService.getCompetitiveTrends", error, "dashboard", chartApp);
          }
        });
    }
  }
  async getRanks(numberOfTiers, surveyGroupId, rankType, period, surveyCode, callback, chartApp) {
    if (!UserService.isLoggedIn()) {
      return;
    }
    if (surveyGroupId == ""){
      surveyGroupId = 0;
    }
    const params = new URLSearchParams();
    params.append("clientCode", ClientService.getClientCode());
    params.append("numberOfTiers", numberOfTiers);
    params.append("surveyGroupId", surveyGroupId);
    params.append("rankType", rankType);
    params.append("period", period);
    params.append("surveyCode", surveyCode);
    params.append("userId", UserService.getUserId());
    await axios
      .post(API_URL + "/get-ranks", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        if (!error.message.includes("getAttribute")) {
          error.message += ErrorService.mergeError(error.response);
          ErrorService.processError("DashboardService.getRanks", error, "survey-designer", chartApp);
        }
      });
  }

  async getPerformanceTrends(performance, metric, useMetricGrowth, callback, chartApp) {
    if (!UserService.isLoggedIn()) {
      return;
    }
    let clientId = ClientService.getClientId();
    let surveyId = SurveyService.getSurveyId();
    if (surveyId == 0){
      chartApp.displayDashboard = true;
    }
    if (clientId != 0 && surveyId != 0) {
      const params = new URLSearchParams();
      params.append("clientCode", ClientService.getClientCode());
      params.append("performance", performance);
      params.append("metric", metric);
      params.append("useMetricGrowth", useMetricGrowth);
      params.append("userId", UserService.getUserId());
      params.append("surveyId", surveyId);
      await axios
        .post(API_URL + "/get-performance-trends", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          if (!error.message.includes("getAttribute")) {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("DashboardService.getPerformanceTrends", error, "survey-designer", chartApp);
          }
        });
    }
  }
  async getNPSTrends(value, callback, chartApp) {
    let clientTimePeriodId = value;
    let clientId = ClientService.getClientId();
    let surveyId = SurveyService.getSurveyId();
    if (surveyId == 0){
      chartApp.displayDashboard = true;
    }    
    if (clientId != 0 && surveyId != 0) {
      const params = new URLSearchParams();
      params.append("clientCode", ClientService.getClientCode());
      params.append("clientTimePeriodId", clientTimePeriodId);
      params.append("userId", UserService.getUserId());
      params.append("surveyId", surveyId);
      await axios
        .post(API_URL + "/get-nps-trends", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          if (!error.message.includes("getAttribute")) {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("DashboardService.getNPSTrends", error, "dashboard", chartApp);
          }
        });
    }
  }
  async getRespondents(ctpId, viewBy, callback, chartApp) {
    let clientTimePeriodId = ctpId;
    let clientId = ClientService.getClientId();
    let surveyId = SurveyService.getSurveyId();
    if (surveyId == 0){
      chartApp.displayDashboard = true;
    }
    if (clientId != 0 && surveyId != 0) {
      const params = new URLSearchParams();
      params.append("clientCode", ClientService.getClientCode());
      params.append("clientTimePeriodId", clientTimePeriodId);
      params.append("userId", UserService.getUserId());
      params.append("surveyId", surveyId);
      params.append("viewBy", viewBy);
      await axios
        .post(API_URL + "/get-respondents", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          if (!error.message.includes("getAttribute")) {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("DashboardService.getNumberOfRepondents", error, "survey-designer", chartApp);
          }
        });
    }
  }
  async getCompetitorSet(callback, chartApp) {
    if (!UserService.isLoggedIn()) {
      return;
    }
    let surveyId = SurveyService.getSurveyId();
    if (surveyId == 0){
      chartApp.displayDashboard = true;
    } else {
      const params = new URLSearchParams();
      params.append("userId", UserService.getUserId());
      params.append("surveyId", surveyId);

      await axios
        .post(API_URL + "/get-competitor-set-by-survey-id", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          error.message += ErrorService.mergeError(error.response);
          ErrorService.processError("DashboardService.getCompetitorSet", error, "admin", chartApp);
        });
    }
  }
  async getDashboardCardTypes(callback, chartApp) {
    if (!UserService.isLoggedIn()) {
      return;
    }
    await axios
      .get(API_URL + "/get-dashboard-card-types", { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("DashboardService.getDashboardCardTypes", error, "admin", chartApp);
      });
  }
  async saveAllDashboardCardTypesAsCards(dashboardCardTypes) {
    localStorage.setItem("dashboard-layout-cards", JSON.stringify(dashboardCardTypes));
  }
  async getAllDashboardCardTypesAsCards() {
    if (localStorage.getItem("dashboard-layout-cards") != null) {
      return JSON.parse(localStorage.getItem("dashboard-layout-cards"));
    } 
    return [];
  }
  async getAllDashboardCardTypesAsCardsFromDatabase(callback, chartApp) {
    if (!UserService.isLoggedIn()) {
      return;
    }
    const params = new URLSearchParams();
    params.append("userId", UserService.getUserId());

    await axios
      .post(API_URL + "/get-all-dashboard-card-types-as-cards", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("DashboardService.getDashboardCards", error, "admin", chartApp);
      });
  }
  async getDashboardCards(userId, callback, chartApp) {
    if (!UserService.isLoggedIn()) {
      return;
    }
    const params = new URLSearchParams();
    params.append("userId", userId);

    await axios
      .post(API_URL + "/get-dashboard-cards", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("DashboardService.getDashboardCards", error, "admin", chartApp);
      });
  }
  async saveDashboardCards(userId, dashboardCards, callback, chartApp) {
    if (!UserService.isLoggedIn()) {
      return;
    }
    const params = new URLSearchParams();
    params.append("dashboardCards", JSON.stringify(dashboardCards));
    params.append("userId", userId);

    await axios
      .post(API_URL + "/save-dashboard-cards", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("DashboardService.getDashboardCards", error, "admin", chartApp);
      });
  }
  getRivalOptions() {
    return [
      { name: "Survey", value: "survey" },
      { name: "Organization (Level)", value: "org" },
      { name: "Benchmark", value: "w30" }
    ];
  }
  setSeries(baseSeries, finalSeries, dynamicOptions) {
    if (typeof dynamicOptions != "undefined" && typeof dynamicOptions.series != "undefined" && typeof finalSeries != "undefined") {
      finalSeries = [];
      for (var seriesIndex = 0; seriesIndex < dynamicOptions.series.length; seriesIndex++) {
        let newSeries = {};
        $.extend(true, newSeries, baseSeries);
        $.extend(true, newSeries, dynamicOptions.series[seriesIndex]);
        finalSeries.push(newSeries);
      }
    }
    return finalSeries;
  }
  setIndividualSeries(baseSeries, seriesIndex, dynamicOptions) {
    let newSeries = {};
    $.extend(true, newSeries, baseSeries);
    if (typeof dynamicOptions != "undefined" && typeof dynamicOptions.series != "undefined" && typeof dynamicOptions.series[seriesIndex] != "undefined") {
      $.extend(true, newSeries, dynamicOptions.series[seriesIndex]);
      dynamicOptions.series[seriesIndex] = JSON.parse(JSON.stringify(newSeries));
    }
  }
  setLegend(finalLegend, dynamicOptions) {
    if (
      typeof dynamicOptions != "undefined" &&
      typeof dynamicOptions.legend != "undefined" &&
      typeof dynamicOptions.legend.data != "undefined" &&
      typeof finalLegend != "undefined"
    ) {
      finalLegend = dynamicOptions.legend.data;
    }
    return finalLegend;
  }

  getExpectationsMapOptions(echarts) {
    var formatUtil = echarts.format;
    let option = {
      title: {
        show: false
      },
      tooltip: {
        formatter: function(info) {
          var value = info.value;
          var treePathInfo = info.treePathInfo;
          var treePath = [];

          for (var i = 1; i < treePathInfo.length; i++) {
            treePath.push(treePathInfo[i].name);
          }

          return ['<div class="tooltip-title">' + formatUtil.encodeHTML(treePath.join(" / ")) + "</div>"].join("");
        }
      },
      textStyle: {
        fontFamily: "Franklin Gothic Medium Cond",
        fontSize: 12
      },
      series: {}
    };
    return option;
  }
  getCompetitiveRankOptions(competitorSet, max) {
    let categories = ["", "NPS", "Satisfaction", "Satisfaction Gaps", "Emotions Gaps", "Pricing Power", "Moat Score", ""];
    let option = {
      title: {
        text: ""
      },
      grid: {
        top: 30,
        left: "8%",
        right: "8%",
        bottom: "16%",
        show: true,
        backgroundColor: "#F8F8F8"
      },
      legend: {
        data: [],
        textStyle: {
          fontSize: DEFAULT_FONT_SIZE,
          fontFamily: "Franklin Gothic Demi Cond",
            color: "#000"
        },
        show: false
      },
      tooltip: {
        position: "top",
        formatter: function(params) {
          let returnValue = params.value[2] + " ranks #" + params.value[1] + " out of " + params.value[3];
          returnValue += " <br> ";
          returnValue += params.value[4];
          return returnValue;
        }
      },
      xAxis: getCompetitiveXAxis(categories),
      yAxis: getCompetititveYAxis(max),
      series: []
    };
    return option;
  }
  getPredictiveAnalyticsOptions() {
    var hours = ["Performance", "Gap", "Pricing Power", "Predictive"];
    var days = ["Product Quality", "Safe to Use", "Innovation", "Product Usefulness", "Brand Reputation"];
    var data = [];

    data = data.map(function(item) {
      return [item[1], item[0], item[2] || "-"];
    });
    let option = {
      tooltip: {
        position: "top"
      },
      animation: false,
      grid: {
        height: "50%",
        top: 20,
        left: "150px"
      },
      xAxis: {
        type: "category",
        data: hours,
        splitArea: {
          show: true
        }
      },
      yAxis: {
        type: "category",
        data: days,
        splitArea: {
          show: true
        }
      },
      legend: {
        textStyle: {
          fontSize: DEFAULT_FONT_SIZE,
          fontFamily: "Franklin Gothic Demi Cond",
        },
        show: false
      },      
      visualMap: {
        min: 0,
        max: 10,
        calculable: true,
        orient: "horizontal",
        left: "center",
        bottom: "15%"
      },
      series: [
        {
          name: "Punch Card",
          type: "heatmap",
          data: data,
          label: {
            normal: {
              show: true
            }
          },
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          },
          width: "95%",
          height: "100%"
        }
      ]
    };
    return option;
  }
  getCompetitiveTrendsOptions(competitorSet, max) {
    return {
      title: {
        text: ""
      },
      tooltip: {
        trigger: "axis",

        formatter: function(params) {
          // 2019 - Q4,2,RoadRunner,5,2019 - Q4: ,Challenger,1,RoadRunner,2
          if (typeof params[0].value != "undefined") {
            let mainCompanyRankingObject = params[0].value;
            let timePeriod = mainCompanyRankingObject[0];
            let mainRanking = mainCompanyRankingObject[1];
            let mainCompany = mainCompanyRankingObject[2];
            let timePeriodDisplayName = mainCompanyRankingObject[4];

            let returnValue = timePeriodDisplayName;
            returnValue += " <br> ";
            returnValue += mainCompany + " : " + mainRanking;

            if (typeof mainCompanyRankingObject[5] != "undefined") {
              let otherRankings = mainCompanyRankingObject[5];
              $.each(otherRankings, function(i, item) {
                returnValue += " <br> ";
                returnValue += item.name + " : " + item.ranking;
              });
            }
            return returnValue;
          }
        }
      },
      grid: {
        top: 30,
        left: "3%",
        right: "4%",
        bottom: "3%",
        backgroundColor: "#F8F8F8",
        containLabel: true,
        show: true
      },
      legend: {
        textStyle: {
          fontSize: DEFAULT_FONT_SIZE,
          fontFamily: "Franklin Gothic Demi Cond",
        },
        show: false
      },
      yAxis: getCompetititveYAxis(max),
      xAxis: {
        type: "category",
        data: [],
        boundaryGap: true,
        splitLine: {
          show: false,
          lineStyle: {
            color: "#DCDCDC"
          }
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          fontSize: DEFAULT_FONT_SIZE,
          fontFamily: "Franklin Gothic Demi Cond",
          formatter: function(name) {
            return timePeriodFormatter(name);
          }
        }
      }
    };
  }
  getMoatScoreRankOptions(echarts) {
    let option = {
      "legend": {
        "show": false,
      },
      "grid": {
        "top": 5,
        "right": "30%",
        "height": "100%",
        "show": true,
        "backgroundColor": "#F8F8F8",
      },
      "xAxis": {
        "show": false,
        "type": "category",
        "data": [
          "Moat Score"
        ]
      },
      "yAxis": [
        {
          "boundaryGap": true,
          "type": "value",
          "axisTick": {
            "show": false
          },
          "axisLabel": {
            "fontSize": 10,
            "fontFamily": "Franklin Gothic Demi Cond",
            "color": "#7F7F7F",
            "formatter": "{value} %"
          },
          "axisLine": {
            "show": false,
          },          
          "splitLine": {
            "show": false,
            "lineStyle": {
              "color": "#fff"
            }
          },
          "min": 0,
          "max": 100,
          "splitNumber": 10,
          "position": "right"
        },
      ],
      "series": [
        {
          "name": "Moat Score",
          "type": "scatter",
          "symbolSize": 14,
          "itemStyle": {
            "color": "#1C408E"
          },
          "label": null,
          "data": [],
          "step": "false",
          "markArea": {
            data: [
              [ { yAxis: 0 }, { yAxis: 15,  itemStyle:{color: "#FBF5F5"} } ],
              [ { yAxis: 15 }, { yAxis: 35,  itemStyle:{color: "#FFFFEE"} } ],        
              [ { yAxis: 35 }, { yAxis: 75,  itemStyle:{color: "#FEFEFD"} } ],
              [ { yAxis: 75 }, { yAxis: 90,  itemStyle:{color: "#FAFBF6"} } ],
              [ { yAxis: 90 }, { yAxis: 100,  itemStyle:{color: "#F3F7EC"} } ]
            ],
          },
          "color": "",
          "symbol": "image://data:image/png;base64,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"
        },
      ],
      "tooltip": {
        "trigger": "axis"
      }
    }
    return option;    
  }
  getNeedsProfileOptions(echarts) {
    let option = {
      legend: {
        left: 0,
        type: 'scroll',
        textStyle: {
          fontSize: DEFAULT_FONT_SIZE,
          fontFamily: "Franklin Gothic Demi Cond",
        },
        itemWidth:15,
        itemStyle: {
          decal: {
            symbolSize: 0,
            symbolKeepAspect: true
          }
        },        
        show: true
      },
      grid: {
        top: 30,
        left: "10%",
        right: "12%",
        show: true,
        backgroundColor: "#F8F8F8"
      },       
      xAxis: {
        show: true,
        axisLabel: {
          fontSize: DEFAULT_FONT_SIZE,
          fontFamily: "Franklin Gothic Demi Cond",
          formatter: function(name) {
            return wordBreakFormatter(name);
          },
          interval: 0
        },    
        
        axisTick: {
          show: false
        },            
        type: 'category',
        data: []
      },
      yAxis: [
        {
          "boundaryGap": true,
          "type": "value",
          "axisTick": {
            show: false
          },
          "axisLabel": {
            "fontSize": 10,
            "fontFamily": "Franklin Gothic Demi Cond",
            color: "#1663E0",
            "formatter": "{value}"
          },
          "splitLine": {
            show: true,
            lineStyle: {
              color: "#fff"
            }
          },
          min: 1,
          max: 10,
          splitNumber: 10,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#000"
            }
          }
        },
        {
          type: "value",
          boundaryGap: true,
          splitLine: {
            show: false
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#000"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#339966",
            fontFamily: "Franklin Gothic Demi Cond",
            fontSize: 10,
            formatter: "{value} %"
          },
          min: 0,
          splitNumber: 5,
        }
          ],
      series: [ {},{},{},{} ],
      tooltip: {
        trigger: "axis",
      },

    };
    return option;
  }
  getPerformanceTrendsOptions(echarts) {
    let option = {
      backgroundColor: "#fff",
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow"
        },
        formatter: function(params) {
          let returnValue = "";
          if (params.length > 0 && typeof params[0].value != "undefined") {
            let metricObject = params[0].value;
            
            let metricValue = metricObject[1];
            let timePeriodDisplayName = metricObject[2];
            let metricName = metricObject[3];
            let prefix = metricObject[4];
            let suffix = metricObject[5];

            returnValue = timePeriodDisplayName;
            returnValue += " <br> ";
            returnValue += metricName + " : " + prefix + " " + metricValue + suffix;
          }
          if (params.length > 1 && typeof params[1].value != "undefined") {
            let performanceObject = params[1].value;
            let performanceValue = performanceObject[1];
            let performanceName = performanceObject[3];
            let performancePrefix = performanceObject[4];
            let performanceSuffix = performanceObject[5];
            let performanceDisplay = performanceObject[6];

            returnValue += " <br> ";
            returnValue += performanceName + " : " + performanceDisplay;
          }
          return returnValue;
        }        
      },
      legend: {
        data: ["Revenue", "Satisfaction"],
        show: false,
        textStyle: {
          fontSize: DEFAULT_FONT_SIZE,
          fontFamily: "Franklin Gothic Demi Cond",
          color: "#000"
        }
      },
      grid: {
        top: 30,
        left: "13%",
        right: "16%",
        bottom: "12%",
        show: true,
        backgroundColor: "#F8F8F8"
      },
      xAxis: {
        data: [],
        axisTick: {
          show: false
        },
        axisLabel: {
          fontSize: DEFAULT_FONT_SIZE,
          fontFamily: "Franklin Gothic Demi Cond",
          formatter: function(name) {
            return timePeriodFormatter(name);
          }
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: "#000"
          }
        },
        splitLine: {
          show: true,
          interval: 3,
          lineStyle: {
            color: "#fff",
            width: 5
          }
        }
      },
      yAxis: [
        {
          boundaryGap: true,
          type: "value",
          axisTick: {
            show: false
          },
          axisLabel: {
            fontSize: DEFAULT_FONT_SIZE,
            fontFamily: "Franklin Gothic Demi Cond",
            color: "#1663E0"
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#fff"
            }
          },
          min: 1,
          max: 10,
          splitNumber: 10,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#000"
            }
          }
        },
        {
          type: "value",
          boundaryGap: true,
          splitLine: { show: false },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#000"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#339966",
            fontFamily: "Franklin Gothic Demi Cond",
            fontSize: DEFAULT_FONT_SIZE,
            showMinLabel: false,
            showMaxLabel: false
          }
        }
      ],
      series: [
        {
          name: "Satisfaction"
        },
        {
          name: "Revenue"
        }
      ]
    };
    return option;
  }
  getNPSTrendsOptions() {
    let option = {
      scales: {
        yAxes: [{
            ticks: {
                beginAtZero:true
            }
        }]
      },      
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        textStyle: {
          fontSize: DEFAULT_FONT_SIZE,
          fontFamily: "Franklin Gothic Demi Cond",
        },
        show: false
      },
      grid: {
        top: 30,
        left: "7%",
        right: "1%",
        bottom: "12%",
        show: true,
        backgroundColor: "#F8F8F8"
      },
      yAxis: {
        type: 'value',
        show: false,
      },
      xAxis: {
        type: 'category',
        axisLabel: {
          fontSize: DEFAULT_FONT_SIZE,
          fontFamily: "Franklin Gothic Demi Cond",
          formatter: function(name) {
            return timePeriodFormatter(name);
          }
        },    
        axisTick: {
          show: false
        },            
        data: []
      },
      series: []
    };
    return option;
  }
  getRespondentMapOptions() {
    let options = {
      title: {
        text: "",
        subtext: "",
        sublink: "",
        left: "right"
      },
      tooltip: {
        trigger: "item",
        showDelay: 0,
        transitionDuration: 0.2,
        formatter: function(params) {
          if (params.value != "null") {
            var value = (params.value + "").split(".");
            if (isNaN(value)) {
              value = 0;
            } else {
              value = value[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, "$1,");
            }
            return params.seriesName + "<br/>" + params.name + ": " + value;
          } else {
            return "";
          }
        }
      },
      visualMap: {
        show: false,
        dimension: 0,
        min: 0,
        max: 100,
        range: [0, 100],
        inRange: {
          color: "#8FAADC"
        },
        outOfRange: {
          color: "red"
        }
      },
      toolbox: {
        show: false,
        left: "left",
        top: "top"
      },
      series: [
        {
          name: "Respondents",
          type: "map",
          roam: true,
          map: "respondent-map",
          emphasis: {
            label: {
              show: true
            }
          },
          textFixed: {
            Alaska: [-131, 25, 15],
            Hawaii: [-110, 28, 5]
          },
          data: []
        }
      ]
    };
    return options;
  }
  getFilterPredictiveAnalyticsColumns() {
    return [
      TableService.getOrderSequence(),
      {
        targets: [0],
        visible: true,
        className: "predictive-text-column predictive-border-column",
        createdCell: function(td, cellData, rowData, row, col) {
          let baseClass = "predictive-text-column predictive-border-column";
          if (cellData == "Customer NPS") {
            $(td).addClass(baseClass + " customer-nps-column ");
          } else if (
            cellData == "Connected" ||
            cellData == "Precise" ||
            cellData == "Like-Minded" ||
            cellData == "Stable" ||
            cellData == "Imaginative" ||
            cellData == "Tough-Minded" ||
            cellData == "Flexible" ||
            cellData == "Detached" ||
            cellData == "Practical" ||
            cellData == "Assurance" ||
            cellData == "Curiosity" ||
            cellData == "Strictness" ||
            cellData == "Trust" ||
            cellData == "Activity" ||
            cellData == "Anxious"
          ) {
            $(td).addClass(baseClass + " emotional-needs-column ");
          }
        }
      },
      {
        targets: [1],
        createdCell: function(td, cellData, rowData, row, col) {
          if (cellData >= 0.8 && cellData < 1.0) {
            $(td).addClass("very-strong-correlation");
          } else if (cellData >= 0.5 && cellData < 0.8) {
            $(td).addClass("strong-correlation");
          } else if (cellData >= 0.3 && cellData < 0.5) {
            $(td).addClass("mild-correlation");
          }
        },
        render(v) {
          if (v != null && !isNaN(v) && v != 0) {
            return Number(v).toFixed(2);
          }
          return "--";
        }
      },
      TableService.getNumericTableAttribute([3], "", 50, 2),
      TableService.getPercentTableAttribute([4], "", 50, 2)
    ];
  }
  getDashboardPredictiveAnalyticsConfiguration(numberOfRows = 100) {
    return {
      columnDefs: this.getFilterPredictiveAnalyticsColumns(),
      buttons: [],
      ordering: true,
      rowCallback: function(row, data, displayNum, displayIndex, dataIndex) {
        if (displayIndex > numberOfRows) {
          $(row).hide();
        } else {
          $(row).show();
        }
      },
      searching: false,
      paging: false,
      pageLength: 15,
      select: true,
      processing: false,
      responsive: true,
      destroy: true,
      info: false,
      keys: true,
      sort: false,
      bSortable: false,
      bSort: false,
    };
  }
}
export default new DashboardService();
